import { useContext, useEffect } from 'react';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { ShellSlotsContext } from './shellSlotsContext';

export interface ShellSubNavProps {
    /** Phone toggle text and the drawer's title ("Pages"). */
    label: string;
    /** Phone toggle note ("142 pages"). */
    meta?: string;
    children: ReactNode;
}

/**
 * A screen's contribution to the shell's sub-nav column (the page tree): portalled into the column on desktop and into
 * a drawer on phones; rendered in place when there is no shell (tests). The shell only shows the column while one is
 * mounted.
 */
export function ShellSubNav(props: ShellSubNavProps) {
    const slots = useContext(ShellSlotsContext);
    const register = slots?.register;
    const { label, meta } = props;

    useEffect(() => {
        if (!register) return;
        register({ label, meta });
        return () => register(null);
    }, [register, label, meta]);

    if (!slots) return <>{props.children}</>;
    if (!slots.target) return null;
    return createPortal(props.children, slots.target);
}
